export const thunderstormATSGroups = 'Thunderstorm Components';
export const thunderstormCapabilitiesGroup = 'Thunderstorm Capabilities';
//# sourceMappingURL=consts.js.map